module.exports = __webpack_public_path__ + "static/media/54.940abce7.gif";